import React from "react";

const WhoWeWorkWithSection: React.FC = () => {
    const collaborations = [
        "Startups and product teams",
        "Businesses and enterprises",
        "Designers, makers, and creative professionals",
        "Individuals looking for unique or customized solutions"
    ];

    return (
        <>
            <style>{`
            @media (max-width: 700px) {
                .collaborations-list-container {
                    grid-template-columns: 1fr !important;
                    gap: 20px !important;
                    padding: 0 15px !important;
                }
                .collaboration-item {
                    padding: 20px !important;
                    width: 100% !important;
                }
                .collaboration-item span {
                    font-size: 16px !important;
                }
                .collaboration-item .dot {
                    width: 10px !important;
                    height: 10px !important;
                    margin-right: 15px !important;
                }
            }
        `}</style>
            <section
                className="elementor-section elementor-top-section elementor-element elementor-section-boxed elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                data-element_type="section"
                style={{
                    padding: '60px 0',
                    backgroundColor: '#F8F8F8' // Matching scheme_default bg
                }}
            >
                <div className="elementor-container elementor-column-gap-extended">
                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">

                            {/* Header Section */}
                            <div className="elementor-element sc_fly_static elementor-widget elementor-widget-trx_sc_title animated fadeIn" data-element_type="widget">
                                <div className="elementor-widget-container">
                                    <div className="sc_title sc_title_default">
                                        <div
                                            className="sc_item_descr sc_title_descr sc_align_center"
                                            style={{
                                                fontFamily: '"Open Sans", sans-serif',
                                                fontSize: '20px',
                                                color: '#797C7F',
                                                marginBottom: '20px'
                                            }}
                                        >
                                            <p></p>
                                        </div>
                                        <h2
                                            className="sc_item_title sc_title_title sc_align_center sc_item_title_style_default sc_item_title_tag"
                                            style={{
                                                fontFamily: '"Red Hat Display", sans-serif',
                                                fontSize: '48px',
                                                fontWeight: 700,
                                                color: '#1B1E25',
                                                marginBottom: '50px'
                                            }}
                                        >
                                            <span className="sc_item_title_text"></span>
                                        </h2>

                                    </div>
                                </div>
                            </div>
                            <div style={{ marginBottom: '60px' }} data-animation-type="block" className="elementor-element elementor-element-3128c39 animation_type_block sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited animated fadeIn" data-id="3128c39" data-element_type="widget" data-settings='{"_animation":"fadeIn"}' data-widget_type="trx_sc_title.default">
                                <div className="elementor-widget-container">
                                    <div className="sc_title sc_title_default"><span className="sc_item_subtitle sc_title_subtitle sc_align_center sc_item_subtitle_above sc_item_title_style_default">Who We Work With</span><h1 className="sc_item_title sc_title_title sc_align_center sc_item_title_style_default sc_item_title_tag"><span className="sc_item_title_text">We collaborate with</span></h1></div>				</div>
                            </div>
                            {/* List Section */}
                            <div
                                className="collaborations-list-container"
                                style={{
                                    maxWidth: '800px',
                                    margin: '0 auto',
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                                    gap: '30px',
                                    padding: '0 20px'
                                }}
                            >
                                {collaborations.map((item, index) => (
                                    <div
                                        key={index}
                                        className="collaboration-item animated fadeInUp"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '25px',
                                            backgroundColor: '#ffffff',
                                            borderRadius: '12px',
                                            boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                            cursor: 'default',
                                            animationDelay: `${index * 0.1}s`
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-5px)';
                                            e.currentTarget.style.boxShadow = '0 15px 40px rgba(238, 85, 54, 0.1)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.05)';
                                        }}
                                    >
                                        <div
                                            className="dot"
                                            style={{
                                                width: '12px',
                                                height: '12px',
                                                backgroundColor: '#EE5536', // Theme accent color
                                                borderRadius: '50%',
                                                marginRight: '20px',
                                                flexShrink: 0
                                            }}
                                        />
                                        <span
                                            style={{
                                                fontFamily: '"Red Hat Display", sans-serif',
                                                fontSize: '18px',
                                                fontWeight: 600,
                                                color: '#1B1E25'
                                            }}
                                        >
                                            {item}
                                        </span>
                                    </div>
                                ))}
                            </div>
                            <div className="elementor-element sc_fly_static elementor-widget elementor-widget-trx_sc_title animated fadeIn" data-element_type="widget" style={{ marginTop: '60px', textAlign: 'center' }}>
                                <div className="elementor-widget-container">
                                    <div className="sc_title sc_title_default">
                                        <div
                                            className="sc_item_descr sc_title_descr sc_align_center"
                                            style={{
                                                fontFamily: '"Open Sans", sans-serif',
                                                fontSize: '18px',
                                                fontStyle: 'italic',
                                                color: '#797C7F',
                                                borderTop: '1px solid #E1DFDF',
                                                paddingTop: '30px',
                                                maxWidth: '800px',
                                                margin: '0 auto',
                                                textAlign: 'center'
                                            }}
                                        >
                                            <p>Our services are built to scale—from one-off ideas to growing product lines.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default WhoWeWorkWithSection;
